import type { ICellRendererParams } from "ag-grid-community";
import type { ViewType } from "../../components/organisms/workItemsTable/types";
import type { CQARiskDictionaries } from "../../types/dictionary";
import { CQAChangesRow } from "../../components/molecules/QualityAssessmentRows/CQAChangesRow";
import CQACodersCell from "../../components/molecules/QualityAssessmentRows/CQACodersCell";
import { toMs, formatDate, epochComparator } from "./dosUtil";

const dateOfServiceRenderer =
  () =>
  ({ value, data }: ICellRendererParams) => {
    const raw = value ?? data?.datetime_of_service ?? data?.date_of_service ?? null;
    const ms = toMs(raw);
    if (ms == null) return "N/A";
    return formatDate(ms, data?.tenant_timezone);
  };

const RENDERER_TARGETS = ["cqa_codes", "cqa_changes", "date_of_service"] as const;

export function attachCqaRenderersToViews(
  views: ViewType[],
  cqaRiskDictionaries: CQARiskDictionaries | null,
): void {
  for (const view of views) {
    if (!view?.columns) continue;
    for (const col of view.columns) {
      if (!RENDERER_TARGETS.includes(col.field)) continue;
      if (col.field === "cqa_changes") {
        col.cellRenderer = (ctx: ICellRendererParams) =>
          CQAChangesRow({ data: ctx.data, riskDictionaries: cqaRiskDictionaries });
      } else if (col.field === "cqa_codes") {
        col.cellRenderer = (ctx: ICellRendererParams) => CQACodersCell({ data: ctx.data });
      } else if (col.field === "date_of_service") {
        col.cellRenderer = dateOfServiceRenderer();
        col.comparator = epochComparator;
      }
    }
  }
}
